import { RoleDto } from '../../core/mceapi.client.generated';
import { fromNullable, Option } from '../functions/functional';

export enum Role {

  Authenticated = 'Authenticated',
  FreeTier = 'FreeTier',
  ProTier = 'ProTier',
  Administrator = 'Administrator',
  FreeCreditsUser = 'FreeCreditsUser', 
  SharedBillingMember = 'SharedBillingMember',
}

export function roleToString(role: Role): string {
  return role.toString();
}

export function roleFromString(role: string | null | undefined): Option<Role> {
  return fromNullable(role == null ? undefined : Role[role as keyof typeof Role]);
}

export function roleFromRoleDto(role: RoleDto): Option<Role> {
  return roleFromString(role.role);
}

export function hasRole(roles: RoleDto[], role: Role): boolean {
  return roles.some(r => r.role === role.toString());
}
